/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { a as _arrayLikeToArray, _ as _unsupportedIterableToArray } from './dep-f66447d3.js';

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

export { _toConsumableArray as _, _iterableToArray as a };
//# sourceMappingURL=dep-f41383e1.js.map
